export const LS_KEY_AUTH_EMAIL_VERIFICATION = 'auth.email.verification';

export const LS_KEY_PROPS_PANE_HEIGHT = 'props-pane-height';
